import {
  HiAnnotation,
  HiDownload,
  HiHome,
  HiPaperAirplane,
} from "react-icons/hi";
import { BsBookmarkFill } from "react-icons/bs";
import { MdLibraryBooks } from "react-icons/md";
import { AiFillYoutube } from "react-icons/ai";
import { RiDashboard2Fill } from "react-icons/ri";

export const links = [
  {
    id: 1,
    label: "Home",
    icon: <HiHome className="icon" />,
    url: "/",
  },
  {
    id: 2,
    label: "Dashboard",
    icon: <RiDashboard2Fill className="icon" />,
    url: "/dashboard",
  },
  {
    id: 3,
    label: "Features",
    icon: <BsBookmarkFill className="icon" />,
    url: "/features",
  },
  {
    id: 4,
    label: "Plans",
    icon: <HiPaperAirplane className="icon" />,
    url: "/plans",
  },
  {
    id: 5,
    label: "Tutorials",
    icon: <AiFillYoutube className="icon" />,
    url: "/tutorials",
  },
  {
    id: 6,
    label: "Download",
    icon: <HiDownload className="icon" />,
    url: "/download",
  },
  {
    id: 7,
    label: "Reviews",
    icon: <HiAnnotation className="icon" />,
    url: "/reviews",
  },

  {
    id: 8,
    label: "FAQ",
    icon: <MdLibraryBooks className="icon" />,
    url: "/mostAskedQuestions",
  },
];
